/*! Albatross (C) GrandPad, Inc */
'use strict';

import * as html from './nav-buttons.html';
import Vue from 'vue';

export default Vue.extend({

	render: html.render,
	staticRenderFns: html.staticRenderFns,

	props: {
		disabledNextTooltipText: {
			type: String,
			required: false
		},

		nextDisabled: {
			type: Boolean,
			required: false,
			default: false
		},

		nextText: {
			type: String,
			required: false,
			default: 'Next'
		},

		nextIcon: {
			type: String,
			required: false,
			default: 'right'
		}
	}
});